import { AnnotationMetaDataChangeEvent } from '@augloop/tracelogger-schemas';
export class AnnotationMetaDataChange extends AnnotationMetaDataChangeEvent {
    constructor(properties) {
        super(properties);
        this.eventName = 'AnnotationMetaDataChange';
    }
}
//# sourceMappingURL=annotation-meta-data-change.js.map